<template>
    <span v-if="showed" :class="{'badge': true,[`${color_class}`]: true}">{{text}}</span>
</template>

<script>
export default {
    name: "BadgeTemp",
    props: ['color', 'text', 'to'],
    data: () => ({
        showed: false,
    }),
    mounted() {
        this.showed = !moment().isAfter(this.to + ' 23:59:59');
    },
    computed: {
        color_class() {
            if (this.color === 'red') return 'badge-danger';
            return 'badge-';
        }
    }
}
</script>

<style scoped>

</style>
